module.exports = __webpack_public_path__ + "img/home.933de542.png";